import type { IdUserDto } from '@/services/ws-companies/src/main/resources/rest-api';
import type { CampaignStage, CampaignStatus } from '@/services/ws-digital/src/main/resources/rest-api';
import type { IdAccountDto } from '@/services/ws-orders/src/main/resources/rest-api';
import type { DateRangeType } from '@/js/libs/ui/src/V2';

import type { Option } from 'src/types';

export enum BroadcastUrlType {
  TV = 'tv-positions-v2',
  RADIO = 'radio-positions-v2',
}

export interface BroadcastRouteParams {
  broadcastType: BroadcastUrlType;
}

export type FiltersState = {
  statusStage: CampaignStatus;
  search: string;
  owner: Option<string> | null;
  invoicingAccountId: Option<IdAccountDto> | null;
  accountId: Option<IdAccountDto> | null;
  stages: Option<CampaignStage>[] | null;
  campaignTypeName: Option<string> | null;
  createdByUserId: Option<IdUserDto> | null;
  startDateRange: DateRangeType | null;
  endDateRange: DateRangeType | null;
};

export type Filter = {
  filters: FiltersState;
};
